module.exports = __webpack_public_path__ + "img/hr-H-B-2-load-connect-shadow.729324e3.png";